<template>
    <div class="index-box">
      <div class="mt10 mb20 fs20 bold">编辑h5单页</div>
      <input type="text"  style="height:40px;width:100%;font-size:18px;border:none;text-indent: 10px;background:#eee;" v-model="title" placeholder="这是标题"/>

        <div class="mt10">
            选择编辑模式：

            <span @click="view_type=0" class="pad510 border-gray"  :class="view_type==0?'bg_blue':''">视图</span>
            <span @click="view_type=1" class="pad510 border-gray ml10" :class="view_type==1?'bg_blue':''">源代码</span>


        </div>
      <template v-if="view_type==0">

        <div style="border: 1px solid #ccc;margin-top: 15px;">
          <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"

            />
            <Editor
                style="height: 500px; overflow-y: hidden;"
                v-model="html"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
            />
          </div>
        </template>
        <div v-if="view_type==1" class="mt15">
            <textarea v-model="html2" style="width:98%;height:500px;border:1px solid #ccc;background:#f1f1f1;"></textarea>

        </div>

        <div style="padding:20px 0;">

            <div class="mb-10">


                <div class="mb-10 mt6" style="margin-top: 15px;">
                  是否手机版 ：

                <span @click="diy_free=0" class="pad510 border-gray"  :class="diy_free==0?'bg_blue':''">电脑</span>
                <span @click="diy_free=1" class="pad510 border-gray ml10" :class="diy_free==1?'bg_blue':''">手机</span>


                </div>
                <div class="mb-10 mt6" style="margin-top: 15px;">
                  样式或js代码:  <span style="color:blue;cursor: default" @click="show_body_code=!show_body_code">+展开</span>
                  <textarea v-if="show_body_code" v-model="body_code" style="width:100%;height:500px;border:1px solid #ccc;background:#f8f8f8;margin-top:10px;"></textarea>

                </div>

            </div>

        </div>
        <div style="width: 250px;margin: 60px 37%">
          <el-button class="btn-box"  type="primary" @click="submitForm">修改保存</el-button>
        </div>

    </div>

</template>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {client, getFileNameUUID} from "@/utils/oss";
import { IEditorConfig, createEditor, createToolbar } from '@wangeditor/editor'


export default {
        components: { Editor, Toolbar },
        name: "WebPage",
        data() {
            var that=this;
          return {
              view_type:0,//编辑模式,1=源代码
            dataObj: {}, //存签名信息
            editor: null,
            id: 0,
            yuan_html:'',
            html: '',
              html2:'',
            title:'',
            diy_free:0,
            show_body_code:0,
            body_code:'',
            toolbarConfig: { },
            editorConfig: {
              placeholder: '请输入内容...',
              // MENU_CONF: {},
              MENU_CONF:{
                uploadImage:{
                  async customUpload(file,insertFn) {
                    async function multipartUpload() {
                      let temporary = file.name.lastIndexOf(".");
                      let fileNameLength = file.name.length;
                      let fileFormat = file.name.substring(
                          temporary + 1,
                          fileNameLength
                      );
                      console.log(file)
                      that.$common.Upload({file:file},function(img){
                        insertFn(img, img, img)
                      });
                    }
                    multipartUpload();
                  },
                },
              },
              // MENU_CONF['uploadImage']={},
            },

            mode: 'default',
          }

        },
        mounted() {
            const id = Number(this.$route.params.id);
            if (id === 0){
              this.$router.back();
              return;
            }
            this.id = id;
            setTimeout(this.getLinkInfo,200);
            // setTimeout(() => {
            //   this.html = '<h1 style="text-align: center;">标题</h1><hr/><p><br></p>'
            // }, 1500)
          },
        beforeDestroy() {
          const editor = this.editor
          if (editor == null) return
          editor.destroy() // 组件销毁时，及时销毁编辑器
        },
        methods: {

          onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
          },

          async getLinkInfo() {
            this.isLoading = true;
            console.log(this.id)
            const {ret,data} = await this.$api.webpage.getOne({id:this.id});
            if (ret === 1000){

              this.isLoading = false;
              this.html = data.web_body;
              this.title=data.web_title;
              this.diy_free=data.diy_free;
              this.body_code=data.body_code;
              this.yuan_html=data.web_body;
              this.html2=data.web_body;
              if(this.body_code){
                this.show_body_code=1;
              }
            }
          },

          async submitForm() {
            console.log(this.html)
              var code=this.html;
              if(this.view_type==1){
                  code=this.html2;
              }

              const postData = {
              id: this.id,
              texthtml: code,
              title:this.title,
              diy_free:this.diy_free,
              body_code:this.body_code
            };
            const {ret,data} = await this.$api.webpage.update(postData);
            if (ret === 1000){
              this.$message.success("修改成功");
              await this.$router.push('/tabs/webPageList');
              //await this.$router.push('/conversion/' + data.id);
            }
          },
        },

    }
</script>

<style scoped>
    .index-box{
        width: 940px;
        height: auto;
        margin-left: 80px;
        padding: 30px 120px 30px 40px;
    }
    .index-box .index-title{
        width: 100%;
        height: 28px;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .index-box .btn-box{
        width: 100%;
    }

    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    a{
      text-decoration: none;
      cursor: pointer;
      color: #2e6ab1;
    }

</style>
